// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/images/bg-testimonial.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  box-sizing: border-box;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

* {
  max-height: 1000000px;
  margin: 0;
  padding: 0;
}

body {
  color: #333;
  background: #fff;
  font: 16px/1.6 "Muli", sans-serif;
  min-width: 320px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 400;
}

img {
  max-width: 100%;
  height: auto;
  vertical-align: top;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Muli", sans-serif;
  font-weight: 400;
  margin: 0 0 20px;
  color: inherit;
}

h1 {
  font-size: 46px;
}

h2 {
  font-size: 30px;
}

h3 {
  font-size: 22px;
}

h4 {
  font-size: 18px;
}

h5 {
  font-size: 17px;
}

h6 {
  font-size: 15px;
}

p {
  margin: 0 0 15px;
}

a {
  color: #594bf6;
  text-decoration: none;
  transition: color 0.3s ease;
}

a:hover,
a:focus {
  text-decoration: none;
  color: #594bf6;
}

ul,
.teams-block .image .overlay,
.contact-block .contact-info ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

#wrapper {
  overflow: hidden;
  width: 100%;
  position: relative;
}

.container-fluid {
  margin: 0 auto;
  max-width: 1200px;
}

.content-block ul {
  margin: 0 0 15px;
}

.content-block ul li {
  position: relative;
  padding: 0 0 0 20px;
}

.content-block ul li:before {
  content: '\\f101';
  font-family: 'fontawesome';
  position: absolute;
  top: 0;
  left: 0;
  transition: all 0.3s linear;
  -webkit-transition: all 0.3s linear;
}

.content-block ul li a {
  color: #333;
}

.content-block ul li a:hover {
  color: #594bf6;
}

.btn.btn-primary {
  background: #594bf6;
  border-color: #594bf6;
  padding: 13px 35px;
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
  text-transform: uppercase;
  transition: background 0.3s linear, color 0.3s linear;
  -webkit-transition: background 0.3s linear, color 0.3s linear;
}

.btn.btn-primary:focus,
.btn.btn-primary:hover {
  background: #fff;
  border-color: #594bf6;
  color: #594bf6;
}

.btn.btn-primary .fas {
  margin: 0 0 0 6px;
  font-size: 15px;
}

input[type=text],
input[type=email],
input[type=tel],
input[type=search],
textarea {
  background: #fff;
  border: 1px solid #cccccc;
  margin: 0;
  padding: 5px 15px;
  width: 100%;
  height: 47px;
  color: gray;
  font-size: 16px;
  line-height: 20px;
}

input[type=text]::-webkit-input-placeholder,
input[type=email]::-webkit-input-placeholder,
input[type=tel]::-webkit-input-placeholder,
input[type=search]::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: gray;
}

input[type=text]::-moz-placeholder,
input[type=email]::-moz-placeholder,
input[type=tel]::-moz-placeholder,
input[type=search]::-moz-placeholder,
textarea::-moz-placeholder {
  opacity: 1;
  color: gray;
}

input[type=text]:-moz-placeholder,
input[type=email]:-moz-placeholder,
input[type=tel]:-moz-placeholder,
input[type=search]:-moz-placeholder,
textarea:-moz-placeholder {
  color: gray;
}

input[type=text]:-ms-input-placeholder,
input[type=email]:-ms-input-placeholder,
input[type=tel]:-ms-input-placeholder,
input[type=search]:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  color: gray;
}

input[type=text].placeholder,
input[type=email].placeholder,
input[type=tel].placeholder,
input[type=search].placeholder,
textarea.placeholder {
  color: gray;
}

input[type=text]:focus,
input[type=email]:focus,
input[type=tel]:focus,
input[type=search]:focus,
textarea:focus {
  outline: none;
}

.newsletter-block input[type=text],
.newsletter-block input[type=email],
.newsletter-block input[type=tel],
.newsletter-block input[type=search],
.newsletter-block textarea {
  border: 0;
}

textarea {
  height: 150px !important;
  min-height: 150px !important;
  resize: vertical;
  padding: 10px 15px !important;
}

.title-holder {
  text-align: center;
  margin: 0 0 40px;
}

.title-holder h2 {
  margin: 0 0 5px;
  text-transform: uppercase;
}

.title-holder .subtitle {
  color: #999999;
}

.title-holder .subtitle:before {
  content: '-';
  margin: 0 5px 0 0;
}

.title-holder .subtitle:after {
  content: '-';
  margin: 0 0 0 5px;
}

.socials {
  display: table;
  height: 100%;
  width: 100%;
}

.socials ul {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.socials li {
  display: inline-block;
  vertical-align: top;
  padding: 0 5px;
}

.socials a {
  width: 35px;
  height: 35px;
  background: #fff;
  color: #594bf6;
  border-radius: 50%;
  display: block;
  text-align: center;
  padding: 2px;
  transition: background 0.3s linear, color 0.3s linear;
  -webkit-transition: background 0.3s linear, color 0.3s linear;
}

.socials a:hover {
  background: #594bf6;
  color: #fff;
}

.socials .fab {
  line-height: 2;
}

.go-top {
  width: 50px;
  height: 50px;
  overflow: hidden;
  text-indent: 101%;
  white-space: nowrap;
  transition: all 0.3s linear;
  -webkit-transition: all 0.3s linear;
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: #594bf6;
  border-radius: 3px;
  color: #fff;
  border: 0;
}

.go-top:before {
  width: 13px;
  height: 13px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  content: '';
  border-style: solid;
  border-color: #fff;
  border-width: 1px 1px 0 0;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -3px 0 0 -6px;
}

.go-top:hover {
  background: #594bf6;
}

.pagination>li.active a {
  background: #594bf6;
  border-color: #594bf6;
}

.pagination>li.active a:hover {
  background: #594bf6;
  border-color: #594bf6;
}

.pagination>li>a {
  color: #594bf6;
  transition: all 0.3s linear;
  -webkit-transition: all 0.3s linear;
  padding: 6px 15px 12px;
}

.pagination>li>a:hover {
  background: #594bf6;
  color: #fff;
  border-color: #594bf6;
}

.pagetitle {
  margin: 80px 0 0;
  background: #594bf6;
  color: #fff;
  padding: 50px 0;
}

.pagetitle .title-holder {
  margin: 0;
}

.pagetitle .subtitle {
  color: #e6e6e6;
}

#header {
  padding: 15px 0;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9999;
  background: #594bf6;
  box-shadow: 0 0 8px 0px rgba(0, 0, 0, 0.1);
  transition: all 0.5s linear;
}

#header .navbar {
  padding: 0;
  justify-content: space-between;
  background: none !important;
}

#header .navbar-brand {
  color: #594bf6;
  text-transform: uppercase;
  font-weight: 600;
  height: auto;
  padding: 0;
  font-size: 22px;
  line-height: 1.6;
}

#header .navbar-collapse {
  flex-grow: 0;
}

#header .navbar-collapse .navbar-nav {
  font-size: 20px;
  line-height: 20px;
}

#header .navbar-collapse a:last-child {
  padding-right: 0;
}

#header .navbar-collapse a {
  color: #fff;
  position: relative;
}

#header .navbar-collapse a:hover,
#header .navbar-collapse a.active {
  background: none;
  color: #000000;
}

#header .navbar-collapse a:hover:before,
#header .navbar-collapse a.active:before {
  right: 7px;
  left: 8px;
  opacity: 1;
}

#header .navbar-collapse a:before {
  content: '';
  background: #594bf6;
  height: 1px;
  position: absolute;
  bottom: 7px;
  left: -20px;
  right: 100%;
  transition: all 0.3s linear;
  -webkit-transition: all 0.3s linear;
  opacity: 0;
}

#footer {
  background: #594bf6;
  padding: 50px 0;
  color: #fff;
  text-align: center;
}

#footer .copyright {
  margin: 0 0 15px;
}

#footer .socials a:hover {
  background: #594bf6;
}

.block {
  padding: 70px 0;
  border-bottom: 1px solid #e6e6e6;
}

.hero-block {
  margin: 65px 0 0;
}

.hero-block .carousel-item:before {
  content: '';
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.hero-block .carousel-item img {
  width: 100%;
}

.hero-block .carousel-caption {
  left: 25%;
  right: 25%;
  transform: translateY(50%);
  -webkit-transform: translateY(50%);
  bottom: 50%;
}

.hero-block p {
  margin: 0 0 30px;
}

.about-block .progress-block {
  margin: 0 0 25px;
}

.about-block .progress-block h4 {
  text-transform: uppercase;
  margin: 0 0 5px;
  font-size: 16px;
}

.about-block .progress-bar {
  background-color: #594bf6;
  transition: width 0.3s linear;
}

.services-block .icon {
  width: 60px;
  height: 60px;
  font-size: 26px;
  color: #594bf6;
  margin: 0 0 20px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
  text-align: center;
  transition: all 0.3s linear;
  -webkit-transition: all 0.3s linear;
}

.services-block .icon .fas {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  line-height: 2;
}

.services-block .row {
  margin: 0 -15px 50px;
}

.services-block .row:last-child {
  margin: 0 -15px;
}

.services-block .holder {
  transition: all 0.3s linear;
}

.services-block .holder:hover {
  margin-top: -5px;
}

.services-block .holder:hover .icon {
  box-shadow: inset 0 0 0 30px #594bf6;
  color: #fff;
  font-size: 18px;
}

.works-block .portfoliolist>div {
  padding: 15px;
  overflow: hidden;
}

.works-block .portfoliolist>div img {
  position: relative;
  top: 0;
  transition: all 600ms cubic-bezier(0.645, 0.045, 0.355, 1);
}

.works-block .portfoliolist>div .label {
  position: absolute;
  height: 60px;
  bottom: -60px;
  left: 0;
  right: 0;
  transition: all 300ms cubic-bezier(0.645, 0.045, 0.355, 1);
  background: rgba(0, 0, 0, 0.8);
  padding: 10px;
  color: #fff;
}

.works-block .portfoliolist>div h3 {
  margin: 0 0 5px;
  color: #594bf6;
  font-size: 16px;
}

.works-block .portfoliolist>div p {
  margin: 0;
  font-size: 12px;
}

.works-block .portfoliolist>div:hover .label {
  bottom: 0;
}

.works-block .portfoliolist>div:hover img {
  transform: scale(1.08);
}

.works-block .portfoliolist .portfolio-wrapper {
  overflow: hidden;
  position: relative !important;
  background: #666;
  cursor: pointer;
  height: auto;
  width: 100%;
}

.works-block .portfoliolist .label {
  font-size: 100%;
}

.works-block .pagination {
  justify-content: center;
  margin: 25px 0 0;
}

.works-block .pagination .page-item.active .page-link {
  background: #594bf6;
  border-color: #594bf6;
}

.works-block .pagination .page-item .page-link {
  padding: 8px 15px 10px;
}

.teams-block div[class*="col"] {
  margin: 0 0 50px;
}

.teams-block .row:last-child {
  margin: 0 -15px;
}

.teams-block [class*="col-"]:hover .overlay {
  top: 0;
  opacity: 1;
}

.teams-block .image {
  margin: 0 0 20px;
  position: relative;
  overflow: hidden;
}

.teams-block .image img {
  width: 100%;
  height: auto;
}

.teams-block .image .overlay {
  position: absolute;
  top: 50%;
  bottom: 0;
  left: 0;
  right: 0;
  transition: all 0.3s linear;
  -webkit-transition: all 0.2s linear;
  vertical-align: middle;
  background: rgba(246, 75, 75, 0.9);
  opacity: 0;
}

.teams-block h3 {
  margin: 0 0 5px;
}

.teams-block .designation {
  display: block;
  font-style: italic;
  margin: 0 0 20px;
}

.testimonials-block {
  padding: 90px 0 70px;
  background-position: 50% 0;
  background-size: cover;
  background-attachment: fixed;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  position: relative;
  color: #fff;
}

.testimonials-block:before {
  content: '';
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.testimonials-block .container-fluid {
  position: relative;
  z-index: 1;
  margin: 0 auto;
  max-width: 900px;
}

.testimonials-block .subtitle {
  color: #cccccc;
}

.testimonials-block blockquote {
  border: 0;
  text-align: center;
  margin: 0;
  padding: 0 0 10%;
}

.testimonials-block cite {
  font-style: normal;
  padding: 15px 0 0;
  display: block;
}

.testimonials-block cite span {
  display: block;
}

.testimonials-block .name {
  margin: 0;
  text-transform: uppercase;
}

.testimonials-block .name:before {
  content: '-';
  margin: 0 5px 0 0;
}

.testimonials-block .designation {
  font-size: 14px;
}

.testimonials-block .carousel-indicators button {
  border: 0;
}

.testimonials-block .carousel-indicators .active {
  background: #594bf6;
}

.pricing-block .row {
  align-items: center;
  margin: 0;
}

.pricing-block .row>div {
  text-align: center;
  padding: 0;
  position: relative;
  overflow: hidden;
}

.pricing-block .heading {
  background: #e6e6e6;
  padding: 15px 60px;
}

.pricing-block .content .list-group-item {
  padding: 10px 20px;
  border: 0;
  background: #f7f7f7;
}

.pricing-block .content .list-group-item:nth-child(2n-1) {
  background: #ededed;
}

.pricing-block .btn-holder {
  padding: 30px 20px;
}

.pricing-block div[class*="col"]:nth-child(2) {
  box-shadow: 0 0 40px 5px #e0e0e0;
  position: relative;
}

.pricing-block div[class*="col"]:nth-child(2) .heading {
  padding: 30px 20px;
  background: #594bf6;
  color: #fff;
}

.pricing-block div[class*="col"]:nth-child(2):before {
  content: 'Popular';
  text-transform: uppercase;
  position: absolute;
  top: 40px;
  left: 40px;
  background: #594bf6;
  color: #fff;
  padding: 5px 10px;
  transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  font-size: 12px;
  text-transform: uppercase;
  width: 150px;
}

.pricing-block h3 {
  text-transform: uppercase;
  margin: 0;
}

.pricing-block .price {
  font-size: 35px;
  line-height: 45px;
}

.blog-block {
  background: #f2f2f2;
}

.blog-block.content-block .holder:hover {
  box-shadow: none;
}

.blog-block.content-block .holder:hover .image img {
  transform: none;
}

.blog-block.content-block .comment-block ul {
  margin: 0;
}

.blog-block.content-block .comment-block li {
  padding: 0;
}

.blog-block.content-block .comment-block li:before {
  display: none;
}

.blog-block .row {
  margin-bottom: 50px;
}

.blog-block .row:last-child {
  margin-bottom: 0;
}

.blog-block .holder {
  background: #fff;
  padding: 15px;
  transition: box-shadow 0.3s linear;
}

.blog-block .holder:hover {
  box-shadow: 0 0 30px 0 #d9d9d9;
}

.blog-block .card {
  border: 0;
}

.blog-block .card-body {
  padding: 0;
}

.blog-block img {
  margin: 0 0 15px;
}

.blog-block time {
  display: block;
  margin: 0 0 10px;
}

.blog-block .card-title {
  margin: 0 0 10px;
  color: #594bf6;
  font-size: 22px;
}

.blog-block .card-title a:hover {
  color: #d10a0a;
}

.blog-block .meta {
  overflow: hidden;
  margin: 0 0 10px;
}

.blog-block .meta time {
  float: left;
  padding: 0 10px 0 0;
}

.blog-block .meta .category {
  float: right;
  padding: 0 0 0 10px;
}

.blog-block .meta .category a {
  color: #333;
}

.blog-block .meta .category a:hover {
  color: #594bf6;
}

.contact-block {
  position: relative;
}

.contact-block .row {
  margin: 0 0 25px;
}

.contact-block .btn-holder {
  text-align: center;
}

.contact-block .contact-form {
  margin: 0 0 60px;
}

.contact-block iframe {
  border: 0;
  width: 100%;
  height: 450px;
}

.contact-block .contact-info {
  padding: 70px 40px 0;
  position: relative;
  z-index: 1;
  font-size: 18px;
  border-radius: 5px;
}

.contact-block .contact-info ul {
  text-align: center;
}

.contact-block .contact-info li {
  display: inline-block;
  vertical-align: top;
  width: 32%;
}

.contact-block .contact-info .fas {
  display: block;
  font-size: 40px;
  margin: 0 0 15px;
  color: #594bf6;
}

@media only screen and (min-width: 1025px) {

  a[href^=tel],
  a[href^=skype],
  a[href^=sms] {
    cursor: default;
    pointer-events: none;
  }
}

@media only screen and (max-width: 1023px) {
  body {
    font-size: 15px;
    line-height: 24px;
  }

  h1 {
    font-size: 34px;
    margin: 0 0 15px;
  }

  h2 {
    font-size: 26px;
    margin: 0 0 15px;
  }

  .btn.btn-primary {
    padding: 9px 35px;
  }

  input[type=text],
  input[type=email],
  input[type=tel],
  input[type=search],
  textarea {
    padding: 5px 10px;
    font-size: 15px;
  }

  #header {
    padding: 10px 0;
  }

  #header .navbar-collapse .navbar-nav {
    float: none;
  }

  #header .navbar-collapse .nav-item {
    float: none;
    display: block;
    padding: 7px 0;
  }

  .hero-block .carousel-caption {
    left: 7%;
    right: 7%;
  }

  .hero-block .carousel-control {
    width: 5%;
  }

  .hero-block p {
    margin: 0 0 25px;
  }

  .works-block .portfoliolist>div .label {
    height: 50px;
  }
}

@media only screen and (max-width: 767px) {
  h2 {
    font-size: 20px;
  }

  h3 {
    font-size: 20px;
  }

  .title-holder {
    margin: 0 0 20px;
  }

  .go-top {
    width: 40px;
    height: 40px;
  }

  .go-top:before {
    width: 11px;
    height: 11px;
  }

  .pagetitle {
    padding: 30px 0;
    margin: 56px 0 0;
  }

  #header .navbar-collapse .navbar-nav {
    margin: 0;
  }

  .block {
    padding: 40px 0 10px;
  }

  .hero-block .carousel-caption {
    display: none;
  }

  .hero-block .carousel-control {
    width: 15%;
  }

  .about-block .image {
    padding-bottom: 20px;
  }

  .about-block .features [class*="col-"] {
    padding-bottom: 30px;
  }

  .about-block .progress-block {
    padding-top: 5px;
  }

  .services-block {
    padding: 40px 0 25px;
  }

  .services-block .row {
    margin-bottom: 0;
  }

  .services-block .holder:hover {
    margin: 0;
  }

  .works-block {
    padding: 40px 0 20px;
  }

  .works-block .portfoliolist>div {
    padding: 0 10px 20px;
  }

  .teams-block {
    text-align: center;
  }

  .teams-block .row {
    margin-bottom: 0;
  }

  .teams-block [class*="col-"] {
    padding-bottom: 20px;
  }

  .teams-block .image {
    max-width: 350px;
    margin: 0 auto 20px;
  }

  .teams-block .designation {
    margin: 0;
  }

  .testimonials-block {
    padding: 50px 0 30px;
  }

  .testimonials-block blockquote {
    font-size: 15px;
  }

  .testimonials-block blockquote p {
    margin: 0;
  }

  .pricing-block {
    padding: 40px 0 20px;
  }

  .blog-block {
    padding: 40px 0 20px;
  }

  .blog-block [class*="col-"] {
    padding-bottom: 20px;
  }

  .blog-block .row {
    margin-bottom: 0;
  }

  .contact-block {
    padding: 40px 0 20px;
  }

  .contact-block [class*="col-"] {
    padding-bottom: 10px;
  }

  .contact-block iframe {
    height: 300px;
  }

  .contact-block .contact-info {
    padding: 30px 0 0;
    font-size: 15px;
  }

  .contact-block .contact-info li {
    display: block;
    width: 100%;
    padding: 0 0 15px;
  }

  .contact-block .contact-info .fas {
    font-size: 26px;
    margin: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;;;;EAME,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qDAAqD;EACrD,6DAA6D;AAC/D;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;;EAKE,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;;;;;EAKE,UAAU;EACV,WAAW;AACb;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;;;EAKE,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,qDAAqD;EACrD,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;EACjC,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,OAAO;EACP,QAAQ;EACR,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,UAAU;EACV,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EAEzB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EAEN,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,OAAO;EACP,QAAQ;EAER,0DAA0D;EAC1D,8BAA8B;EAC9B,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,mCAAmC;EACnC,sBAAsB;EACtB,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,yDAAyD;EACzD,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,2DAA2D;EAC3D,mEAAmE;EACnE,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE;;;IAGE,eAAe;IACf,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;;;IAKE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;AACF","sourcesContent":["html {\n  box-sizing: border-box;\n}\n\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\n\n* {\n  max-height: 1000000px;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  color: #333;\n  background: #fff;\n  font: 16px/1.6 \"Muli\", sans-serif;\n  min-width: 320px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-weight: 400;\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n  vertical-align: top;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Muli\", sans-serif;\n  font-weight: 400;\n  margin: 0 0 20px;\n  color: inherit;\n}\n\nh1 {\n  font-size: 46px;\n}\n\nh2 {\n  font-size: 30px;\n}\n\nh3 {\n  font-size: 22px;\n}\n\nh4 {\n  font-size: 18px;\n}\n\nh5 {\n  font-size: 17px;\n}\n\nh6 {\n  font-size: 15px;\n}\n\np {\n  margin: 0 0 15px;\n}\n\na {\n  color: #594bf6;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\na:hover,\na:focus {\n  text-decoration: none;\n  color: #594bf6;\n}\n\nul,\n.teams-block .image .overlay,\n.contact-block .contact-info ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.ellipsis {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n#wrapper {\n  overflow: hidden;\n  width: 100%;\n  position: relative;\n}\n\n.container-fluid {\n  margin: 0 auto;\n  max-width: 1200px;\n}\n\n.content-block ul {\n  margin: 0 0 15px;\n}\n\n.content-block ul li {\n  position: relative;\n  padding: 0 0 0 20px;\n}\n\n.content-block ul li:before {\n  content: '\\f101';\n  font-family: 'fontawesome';\n  position: absolute;\n  top: 0;\n  left: 0;\n  transition: all 0.3s linear;\n  -webkit-transition: all 0.3s linear;\n}\n\n.content-block ul li a {\n  color: #333;\n}\n\n.content-block ul li a:hover {\n  color: #594bf6;\n}\n\n.btn.btn-primary {\n  background: #594bf6;\n  border-color: #594bf6;\n  padding: 13px 35px;\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: 600;\n  text-transform: uppercase;\n  transition: background 0.3s linear, color 0.3s linear;\n  -webkit-transition: background 0.3s linear, color 0.3s linear;\n}\n\n.btn.btn-primary:focus,\n.btn.btn-primary:hover {\n  background: #fff;\n  border-color: #594bf6;\n  color: #594bf6;\n}\n\n.btn.btn-primary .fas {\n  margin: 0 0 0 6px;\n  font-size: 15px;\n}\n\ninput[type=text],\ninput[type=email],\ninput[type=tel],\ninput[type=search],\ntextarea {\n  background: #fff;\n  border: 1px solid #cccccc;\n  margin: 0;\n  padding: 5px 15px;\n  width: 100%;\n  height: 47px;\n  color: gray;\n  font-size: 16px;\n  line-height: 20px;\n}\n\ninput[type=text]::-webkit-input-placeholder,\ninput[type=email]::-webkit-input-placeholder,\ninput[type=tel]::-webkit-input-placeholder,\ninput[type=search]::-webkit-input-placeholder,\ntextarea::-webkit-input-placeholder {\n  color: gray;\n}\n\ninput[type=text]::-moz-placeholder,\ninput[type=email]::-moz-placeholder,\ninput[type=tel]::-moz-placeholder,\ninput[type=search]::-moz-placeholder,\ntextarea::-moz-placeholder {\n  opacity: 1;\n  color: gray;\n}\n\ninput[type=text]:-moz-placeholder,\ninput[type=email]:-moz-placeholder,\ninput[type=tel]:-moz-placeholder,\ninput[type=search]:-moz-placeholder,\ntextarea:-moz-placeholder {\n  color: gray;\n}\n\ninput[type=text]:-ms-input-placeholder,\ninput[type=email]:-ms-input-placeholder,\ninput[type=tel]:-ms-input-placeholder,\ninput[type=search]:-ms-input-placeholder,\ntextarea:-ms-input-placeholder {\n  color: gray;\n}\n\ninput[type=text].placeholder,\ninput[type=email].placeholder,\ninput[type=tel].placeholder,\ninput[type=search].placeholder,\ntextarea.placeholder {\n  color: gray;\n}\n\ninput[type=text]:focus,\ninput[type=email]:focus,\ninput[type=tel]:focus,\ninput[type=search]:focus,\ntextarea:focus {\n  outline: none;\n}\n\n.newsletter-block input[type=text],\n.newsletter-block input[type=email],\n.newsletter-block input[type=tel],\n.newsletter-block input[type=search],\n.newsletter-block textarea {\n  border: 0;\n}\n\ntextarea {\n  height: 150px !important;\n  min-height: 150px !important;\n  resize: vertical;\n  padding: 10px 15px !important;\n}\n\n.title-holder {\n  text-align: center;\n  margin: 0 0 40px;\n}\n\n.title-holder h2 {\n  margin: 0 0 5px;\n  text-transform: uppercase;\n}\n\n.title-holder .subtitle {\n  color: #999999;\n}\n\n.title-holder .subtitle:before {\n  content: '-';\n  margin: 0 5px 0 0;\n}\n\n.title-holder .subtitle:after {\n  content: '-';\n  margin: 0 0 0 5px;\n}\n\n.socials {\n  display: table;\n  height: 100%;\n  width: 100%;\n}\n\n.socials ul {\n  display: table-cell;\n  vertical-align: middle;\n  text-align: center;\n}\n\n.socials li {\n  display: inline-block;\n  vertical-align: top;\n  padding: 0 5px;\n}\n\n.socials a {\n  width: 35px;\n  height: 35px;\n  background: #fff;\n  color: #594bf6;\n  border-radius: 50%;\n  display: block;\n  text-align: center;\n  padding: 2px;\n  transition: background 0.3s linear, color 0.3s linear;\n  -webkit-transition: background 0.3s linear, color 0.3s linear;\n}\n\n.socials a:hover {\n  background: #594bf6;\n  color: #fff;\n}\n\n.socials .fab {\n  line-height: 2;\n}\n\n.go-top {\n  width: 50px;\n  height: 50px;\n  overflow: hidden;\n  text-indent: 101%;\n  white-space: nowrap;\n  transition: all 0.3s linear;\n  -webkit-transition: all 0.3s linear;\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  background: #594bf6;\n  border-radius: 3px;\n  color: #fff;\n  border: 0;\n}\n\n.go-top:before {\n  width: 13px;\n  height: 13px;\n  transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n  content: '';\n  border-style: solid;\n  border-color: #fff;\n  border-width: 1px 1px 0 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -3px 0 0 -6px;\n}\n\n.go-top:hover {\n  background: #594bf6;\n}\n\n.pagination>li.active a {\n  background: #594bf6;\n  border-color: #594bf6;\n}\n\n.pagination>li.active a:hover {\n  background: #594bf6;\n  border-color: #594bf6;\n}\n\n.pagination>li>a {\n  color: #594bf6;\n  transition: all 0.3s linear;\n  -webkit-transition: all 0.3s linear;\n  padding: 6px 15px 12px;\n}\n\n.pagination>li>a:hover {\n  background: #594bf6;\n  color: #fff;\n  border-color: #594bf6;\n}\n\n.pagetitle {\n  margin: 80px 0 0;\n  background: #594bf6;\n  color: #fff;\n  padding: 50px 0;\n}\n\n.pagetitle .title-holder {\n  margin: 0;\n}\n\n.pagetitle .subtitle {\n  color: #e6e6e6;\n}\n\n#header {\n  padding: 15px 0;\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  z-index: 9999;\n  background: #594bf6;\n  box-shadow: 0 0 8px 0px rgba(0, 0, 0, 0.1);\n  transition: all 0.5s linear;\n}\n\n#header .navbar {\n  padding: 0;\n  justify-content: space-between;\n  background: none !important;\n}\n\n#header .navbar-brand {\n  color: #594bf6;\n  text-transform: uppercase;\n  font-weight: 600;\n  height: auto;\n  padding: 0;\n  font-size: 22px;\n  line-height: 1.6;\n}\n\n#header .navbar-collapse {\n  flex-grow: 0;\n}\n\n#header .navbar-collapse .navbar-nav {\n  font-size: 20px;\n  line-height: 20px;\n}\n\n#header .navbar-collapse a:last-child {\n  padding-right: 0;\n}\n\n#header .navbar-collapse a {\n  color: #fff;\n  position: relative;\n}\n\n#header .navbar-collapse a:hover,\n#header .navbar-collapse a.active {\n  background: none;\n  color: #000000;\n}\n\n#header .navbar-collapse a:hover:before,\n#header .navbar-collapse a.active:before {\n  right: 7px;\n  left: 8px;\n  opacity: 1;\n}\n\n#header .navbar-collapse a:before {\n  content: '';\n  background: #594bf6;\n  height: 1px;\n  position: absolute;\n  bottom: 7px;\n  left: -20px;\n  right: 100%;\n  transition: all 0.3s linear;\n  -webkit-transition: all 0.3s linear;\n  opacity: 0;\n}\n\n#footer {\n  background: #594bf6;\n  padding: 50px 0;\n  color: #fff;\n  text-align: center;\n}\n\n#footer .copyright {\n  margin: 0 0 15px;\n}\n\n#footer .socials a:hover {\n  background: #594bf6;\n}\n\n.block {\n  padding: 70px 0;\n  border-bottom: 1px solid #e6e6e6;\n}\n\n.hero-block {\n  margin: 65px 0 0;\n}\n\n.hero-block .carousel-item:before {\n  content: '';\n  background: rgba(0, 0, 0, 0.7);\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.hero-block .carousel-item img {\n  width: 100%;\n}\n\n.hero-block .carousel-caption {\n  left: 25%;\n  right: 25%;\n  transform: translateY(50%);\n  -webkit-transform: translateY(50%);\n  bottom: 50%;\n}\n\n.hero-block p {\n  margin: 0 0 30px;\n}\n\n.about-block .progress-block {\n  margin: 0 0 25px;\n}\n\n.about-block .progress-block h4 {\n  text-transform: uppercase;\n  margin: 0 0 5px;\n  font-size: 16px;\n}\n\n.about-block .progress-bar {\n  background-color: #594bf6;\n  -webkit-transition: width 0.3s linear;\n  transition: width 0.3s linear;\n}\n\n.services-block .icon {\n  width: 60px;\n  height: 60px;\n  font-size: 26px;\n  color: #594bf6;\n  margin: 0 0 20px;\n  display: inline-block;\n  vertical-align: middle;\n  border-radius: 50%;\n  text-align: center;\n  transition: all 0.3s linear;\n  -webkit-transition: all 0.3s linear;\n}\n\n.services-block .icon .fas {\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n  line-height: 2;\n}\n\n.services-block .row {\n  margin: 0 -15px 50px;\n}\n\n.services-block .row:last-child {\n  margin: 0 -15px;\n}\n\n.services-block .holder {\n  transition: all 0.3s linear;\n}\n\n.services-block .holder:hover {\n  margin-top: -5px;\n}\n\n.services-block .holder:hover .icon {\n  box-shadow: inset 0 0 0 30px #594bf6;\n  color: #fff;\n  font-size: 18px;\n}\n\n.works-block .portfoliolist>div {\n  padding: 15px;\n  overflow: hidden;\n}\n\n.works-block .portfoliolist>div img {\n  position: relative;\n  top: 0;\n  -webkit-transition: all 600ms cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: all 600ms cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n\n.works-block .portfoliolist>div .label {\n  position: absolute;\n  height: 60px;\n  bottom: -60px;\n  left: 0;\n  right: 0;\n  -webkit-transition: all 300ms cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: all 300ms cubic-bezier(0.645, 0.045, 0.355, 1);\n  background: rgba(0, 0, 0, 0.8);\n  padding: 10px;\n  color: #fff;\n}\n\n.works-block .portfoliolist>div h3 {\n  margin: 0 0 5px;\n  color: #594bf6;\n  font-size: 16px;\n}\n\n.works-block .portfoliolist>div p {\n  margin: 0;\n  font-size: 12px;\n}\n\n.works-block .portfoliolist>div:hover .label {\n  bottom: 0;\n}\n\n.works-block .portfoliolist>div:hover img {\n  transform: scale(1.08);\n}\n\n.works-block .portfoliolist .portfolio-wrapper {\n  overflow: hidden;\n  position: relative !important;\n  background: #666;\n  cursor: pointer;\n  height: auto;\n  width: 100%;\n}\n\n.works-block .portfoliolist .label {\n  font-size: 100%;\n}\n\n.works-block .pagination {\n  justify-content: center;\n  margin: 25px 0 0;\n}\n\n.works-block .pagination .page-item.active .page-link {\n  background: #594bf6;\n  border-color: #594bf6;\n}\n\n.works-block .pagination .page-item .page-link {\n  padding: 8px 15px 10px;\n}\n\n.teams-block div[class*=\"col\"] {\n  margin: 0 0 50px;\n}\n\n.teams-block .row:last-child {\n  margin: 0 -15px;\n}\n\n.teams-block [class*=\"col-\"]:hover .overlay {\n  top: 0;\n  opacity: 1;\n}\n\n.teams-block .image {\n  margin: 0 0 20px;\n  position: relative;\n  overflow: hidden;\n}\n\n.teams-block .image img {\n  width: 100%;\n  height: auto;\n}\n\n.teams-block .image .overlay {\n  position: absolute;\n  top: 50%;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  transition: all 0.3s linear;\n  -webkit-transition: all 0.2s linear;\n  vertical-align: middle;\n  background: rgba(246, 75, 75, 0.9);\n  opacity: 0;\n}\n\n.teams-block h3 {\n  margin: 0 0 5px;\n}\n\n.teams-block .designation {\n  display: block;\n  font-style: italic;\n  margin: 0 0 20px;\n}\n\n.testimonials-block {\n  padding: 90px 0 70px;\n  background-position: 50% 0;\n  background-size: cover;\n  background-attachment: fixed;\n  background-image: url('assets/images/bg-testimonial.jpg');\n  position: relative;\n  color: #fff;\n}\n\n.testimonials-block:before {\n  content: '';\n  background: rgba(0, 0, 0, 0.8);\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.testimonials-block .container-fluid {\n  position: relative;\n  z-index: 1;\n  margin: 0 auto;\n  max-width: 900px;\n}\n\n.testimonials-block .subtitle {\n  color: #cccccc;\n}\n\n.testimonials-block blockquote {\n  border: 0;\n  text-align: center;\n  margin: 0;\n  padding: 0 0 10%;\n}\n\n.testimonials-block cite {\n  font-style: normal;\n  padding: 15px 0 0;\n  display: block;\n}\n\n.testimonials-block cite span {\n  display: block;\n}\n\n.testimonials-block .name {\n  margin: 0;\n  text-transform: uppercase;\n}\n\n.testimonials-block .name:before {\n  content: '-';\n  margin: 0 5px 0 0;\n}\n\n.testimonials-block .designation {\n  font-size: 14px;\n}\n\n.testimonials-block .carousel-indicators button {\n  border: 0;\n}\n\n.testimonials-block .carousel-indicators .active {\n  background: #594bf6;\n}\n\n.pricing-block .row {\n  align-items: center;\n  margin: 0;\n}\n\n.pricing-block .row>div {\n  text-align: center;\n  padding: 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.pricing-block .heading {\n  background: #e6e6e6;\n  padding: 15px 60px;\n}\n\n.pricing-block .content .list-group-item {\n  padding: 10px 20px;\n  border: 0;\n  background: #f7f7f7;\n}\n\n.pricing-block .content .list-group-item:nth-child(2n-1) {\n  background: #ededed;\n}\n\n.pricing-block .btn-holder {\n  padding: 30px 20px;\n}\n\n.pricing-block div[class*=\"col\"]:nth-child(2) {\n  box-shadow: 0 0 40px 5px #e0e0e0;\n  position: relative;\n}\n\n.pricing-block div[class*=\"col\"]:nth-child(2) .heading {\n  padding: 30px 20px;\n  background: #594bf6;\n  color: #fff;\n}\n\n.pricing-block div[class*=\"col\"]:nth-child(2):before {\n  content: 'Popular';\n  text-transform: uppercase;\n  position: absolute;\n  top: 40px;\n  left: 40px;\n  background: #594bf6;\n  color: #fff;\n  padding: 5px 10px;\n  transform: translateX(-50%) translateY(-50%) rotate(-45deg);\n  -webkit-transform: translateX(-50%) translateY(-50%) rotate(-45deg);\n  font-size: 12px;\n  text-transform: uppercase;\n  width: 150px;\n}\n\n.pricing-block h3 {\n  text-transform: uppercase;\n  margin: 0;\n}\n\n.pricing-block .price {\n  font-size: 35px;\n  line-height: 45px;\n}\n\n.blog-block {\n  background: #f2f2f2;\n}\n\n.blog-block.content-block .holder:hover {\n  box-shadow: none;\n}\n\n.blog-block.content-block .holder:hover .image img {\n  transform: none;\n}\n\n.blog-block.content-block .comment-block ul {\n  margin: 0;\n}\n\n.blog-block.content-block .comment-block li {\n  padding: 0;\n}\n\n.blog-block.content-block .comment-block li:before {\n  display: none;\n}\n\n.blog-block .row {\n  margin-bottom: 50px;\n}\n\n.blog-block .row:last-child {\n  margin-bottom: 0;\n}\n\n.blog-block .holder {\n  background: #fff;\n  padding: 15px;\n  transition: box-shadow 0.3s linear;\n}\n\n.blog-block .holder:hover {\n  box-shadow: 0 0 30px 0 #d9d9d9;\n}\n\n.blog-block .card {\n  border: 0;\n}\n\n.blog-block .card-body {\n  padding: 0;\n}\n\n.blog-block img {\n  margin: 0 0 15px;\n}\n\n.blog-block time {\n  display: block;\n  margin: 0 0 10px;\n}\n\n.blog-block .card-title {\n  margin: 0 0 10px;\n  color: #594bf6;\n  font-size: 22px;\n}\n\n.blog-block .card-title a:hover {\n  color: #d10a0a;\n}\n\n.blog-block .meta {\n  overflow: hidden;\n  margin: 0 0 10px;\n}\n\n.blog-block .meta time {\n  float: left;\n  padding: 0 10px 0 0;\n}\n\n.blog-block .meta .category {\n  float: right;\n  padding: 0 0 0 10px;\n}\n\n.blog-block .meta .category a {\n  color: #333;\n}\n\n.blog-block .meta .category a:hover {\n  color: #594bf6;\n}\n\n.contact-block {\n  position: relative;\n}\n\n.contact-block .row {\n  margin: 0 0 25px;\n}\n\n.contact-block .btn-holder {\n  text-align: center;\n}\n\n.contact-block .contact-form {\n  margin: 0 0 60px;\n}\n\n.contact-block iframe {\n  border: 0;\n  width: 100%;\n  height: 450px;\n}\n\n.contact-block .contact-info {\n  padding: 70px 40px 0;\n  position: relative;\n  z-index: 1;\n  font-size: 18px;\n  border-radius: 5px;\n}\n\n.contact-block .contact-info ul {\n  text-align: center;\n}\n\n.contact-block .contact-info li {\n  display: inline-block;\n  vertical-align: top;\n  width: 32%;\n}\n\n.contact-block .contact-info .fas {\n  display: block;\n  font-size: 40px;\n  margin: 0 0 15px;\n  color: #594bf6;\n}\n\n@media only screen and (min-width: 1025px) {\n\n  a[href^=tel],\n  a[href^=skype],\n  a[href^=sms] {\n    cursor: default;\n    pointer-events: none;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  body {\n    font-size: 15px;\n    line-height: 24px;\n  }\n\n  h1 {\n    font-size: 34px;\n    margin: 0 0 15px;\n  }\n\n  h2 {\n    font-size: 26px;\n    margin: 0 0 15px;\n  }\n\n  .btn.btn-primary {\n    padding: 9px 35px;\n  }\n\n  input[type=text],\n  input[type=email],\n  input[type=tel],\n  input[type=search],\n  textarea {\n    padding: 5px 10px;\n    font-size: 15px;\n  }\n\n  #header {\n    padding: 10px 0;\n  }\n\n  #header .navbar-collapse .navbar-nav {\n    float: none;\n  }\n\n  #header .navbar-collapse .nav-item {\n    float: none;\n    display: block;\n    padding: 7px 0;\n  }\n\n  .hero-block .carousel-caption {\n    left: 7%;\n    right: 7%;\n  }\n\n  .hero-block .carousel-control {\n    width: 5%;\n  }\n\n  .hero-block p {\n    margin: 0 0 25px;\n  }\n\n  .works-block .portfoliolist>div .label {\n    height: 50px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  h2 {\n    font-size: 20px;\n  }\n\n  h3 {\n    font-size: 20px;\n  }\n\n  .title-holder {\n    margin: 0 0 20px;\n  }\n\n  .go-top {\n    width: 40px;\n    height: 40px;\n  }\n\n  .go-top:before {\n    width: 11px;\n    height: 11px;\n  }\n\n  .pagetitle {\n    padding: 30px 0;\n    margin: 56px 0 0;\n  }\n\n  #header .navbar-collapse .navbar-nav {\n    margin: 0;\n  }\n\n  .block {\n    padding: 40px 0 10px;\n  }\n\n  .hero-block .carousel-caption {\n    display: none;\n  }\n\n  .hero-block .carousel-control {\n    width: 15%;\n  }\n\n  .about-block .image {\n    padding-bottom: 20px;\n  }\n\n  .about-block .features [class*=\"col-\"] {\n    padding-bottom: 30px;\n  }\n\n  .about-block .progress-block {\n    padding-top: 5px;\n  }\n\n  .services-block {\n    padding: 40px 0 25px;\n  }\n\n  .services-block .row {\n    margin-bottom: 0;\n  }\n\n  .services-block .holder:hover {\n    margin: 0;\n  }\n\n  .works-block {\n    padding: 40px 0 20px;\n  }\n\n  .works-block .portfoliolist>div {\n    padding: 0 10px 20px;\n  }\n\n  .teams-block {\n    text-align: center;\n  }\n\n  .teams-block .row {\n    margin-bottom: 0;\n  }\n\n  .teams-block [class*=\"col-\"] {\n    padding-bottom: 20px;\n  }\n\n  .teams-block .image {\n    max-width: 350px;\n    margin: 0 auto 20px;\n  }\n\n  .teams-block .designation {\n    margin: 0;\n  }\n\n  .testimonials-block {\n    padding: 50px 0 30px;\n  }\n\n  .testimonials-block blockquote {\n    font-size: 15px;\n  }\n\n  .testimonials-block blockquote p {\n    margin: 0;\n  }\n\n  .pricing-block {\n    padding: 40px 0 20px;\n  }\n\n  .blog-block {\n    padding: 40px 0 20px;\n  }\n\n  .blog-block [class*=\"col-\"] {\n    padding-bottom: 20px;\n  }\n\n  .blog-block .row {\n    margin-bottom: 0;\n  }\n\n  .contact-block {\n    padding: 40px 0 20px;\n  }\n\n  .contact-block [class*=\"col-\"] {\n    padding-bottom: 10px;\n  }\n\n  .contact-block iframe {\n    height: 300px;\n  }\n\n  .contact-block .contact-info {\n    padding: 30px 0 0;\n    font-size: 15px;\n  }\n\n  .contact-block .contact-info li {\n    display: block;\n    width: 100%;\n    padding: 0 0 15px;\n  }\n\n  .contact-block .contact-info .fas {\n    font-size: 26px;\n    margin: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
